import React, {Component} from "react";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";
import {connect} from "react-redux";
import _ from "lodash";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

import "./SystemSpec.component.scss";
import {HallsActionCreators} from "../../../actions/actionCreators";
import {ActionCreator} from "../../../../../actions/actions";
import {hallsStoreSelectors} from "../../../store/store";
import {checkPermission} from "../../../../../utils/Authorization/authorization";

export interface SystemSpecProps extends RouteComponentProps {
    serverId: number;
    uploadSystemSpec: ActionCreator;
    clearSuccessUploadSpec: ActionCreator;
    specificationActivitiesLoading: boolean;
    specificationActivities: any[];
    specificationUploaded: boolean;
    specificationUploading: boolean;
    showDetail: any;
    serverLicenseState: number;
    perpetualLicense: boolean;
}

export interface SystemSpecState {
    specFile: File;
    licenseDuration: number;
    savedSuccesses: number;
}

class SystemSpec extends Component<SystemSpecProps, SystemSpecState> {
    constructor(props) {
        super(props);

        this.state = {
            specFile: null,
            licenseDuration: 180,
            savedSuccesses: 0
        };
    }

    specFileChange = files => {
        this.setState({
            specFile: files.length === 0 ? null : files[0]
        });
    };

    update = () => {
        this.props.uploadSystemSpec({
            serverId: this.props.serverId,
            file: this.state.specFile
        });
    };

    componentDidUpdate(prevProps) {
        if (
            prevProps.specificationUploaded == false &&
            this.props.specificationUploaded == true
        ) {
            this.setState({
                savedSuccesses: this.state.savedSuccesses + 1,
                specFile: null
            });
            this.props.clearSuccessUploadSpec();
        }
    }

    render() {
        return (
            <div className="panel-specification">
                <h1>System Specification</h1>

                <div className="spec-container">
                    {checkPermission("spec_update") && (this.props.perpetualLicense || this.props.serverLicenseState > 1) && (
                        <div className="update-spec">
                            <div className="mgmt-info">
                                <p>
                                    Download system specification file{" "}
                                    <b>from the server</b> after inserting/updating
                                    configuration.
                                </p>
                            </div>

                            <div>
                                <div className="row no-gutters">
                                    <div className="filebox">
                                        <Components.FileBox
                                            key={this.state.savedSuccesses}
                                            displayMessage="Drag or choose file"
                                            multipleFilesAllowed={false}
                                            displayIcon={""}
                                            onFilesChange={this.specFileChange}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <div>
                                        <button
                                            className={`red-btn update-btn ${
                                                this.props
                                                    .specificationUploading
                                                    ? "loading"
                                                    : ""
                                            }`}
                                            disabled={
                                                !this.state.specFile ||
                                                this.props
                                                    .specificationUploading
                                            }
                                            onClick={this.update}
                                        >
                                            Update
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>)}

                    {checkPermission("spec_update") && !this.props.perpetualLicense && this.props.serverLicenseState === 1 && (
                        <div className="update-spec">
                            <div className="mgmt-info">
                                <p>
                                    This server needs information before a specification can be uploaded.
                                    Please download the license <b>seed</b> on the server and upload it to enable
                                    specifications.
                                </p>
                            </div>
                        </div>
                    )}

                    <div
                        className={`current-spec ${
                            this.props.specificationActivitiesLoading ||
                            (!this.props.specificationActivitiesLoading &&
                                this.props.specificationActivities[
                                    "currentSpec"
                                    ] == null)
                                ? "loading"
                                : ""
                        }`}
                    >
                        {this.props.specificationActivitiesLoading &&
                            this.props.specificationActivities["currentSpec"] ==
                            null && (
                                <Components.LoadingRipple
                                    width={100}
                                    height={100}
                                />
                            )}
                        {!checkPermission("spec_history") && (
                            <p className="no-spec">
                                You need access to Specification history to view the last inserted server Specification.
                            </p>
                        )}
                        {checkPermission("spec_history") && !this.props.specificationActivitiesLoading &&
                            this.props.specificationActivities["currentSpec"] ==
                            null && (
                                <p className="no-spec">
                                    No system specification uploaded at the
                                    moment.
                                </p>
                            )}
                        {checkPermission("spec_history") && !this.props.specificationActivitiesLoading &&
                            this.props.specificationActivities["currentSpec"] !=
                            null && (
                                <React.Fragment>
                                    <div className="col-6 spec">
                                        <span>Config. Version</span>
                                        <p>
                                            {`Version ${this.props.specificationActivities["currentSpec"]["specs"]["config_version"]}`}{" "}
                                            {this.props.specificationActivities["currentSpec"]["specs"]["Server"] &&
                                            this.props.specificationActivities["currentSpec"]["specs"]["Server"]["pendingConfigVersion"] !== 0
                                                ? `(Version ${this.props.specificationActivities["currentSpec"]["specs"]["Server"]["pendingConfigVersion"]} Pending)`
                                                : null}
                                        </p>
                                    </div>
                                    <div className="col-6 spec">
                                        <span>System Server Version</span>
                                        <p>
                                            {
                                                this.props.specificationActivities["currentSpec"]["specs"]["Server"] ?
                                                    this.props.specificationActivities["currentSpec"]["specs"]["Server"]["version"] :
                                                    "N/A"
                                            }
                                        </p>
                                    </div>
                                    <div className="col-6 spec">
                                        <span>Board</span>
                                        <p>
                                            {
                                                this.props
                                                    .specificationActivities[
                                                    "currentSpec"
                                                    ]["specs"]["Hardware"]["Board"][
                                                    "Manufacturer"
                                                    ]
                                            }{" "}
                                            {
                                                this.props
                                                    .specificationActivities[
                                                    "currentSpec"
                                                    ]["specs"]["Hardware"]["Board"][
                                                    "Product Name"
                                                    ]
                                            }
                                        </p>
                                    </div>
                                    <div className="col-6 spec">
                                        <span>CPU</span>
                                        <p>
                                            {
                                                this.props
                                                    .specificationActivities[
                                                    "currentSpec"
                                                    ]["specs"]["Hardware"][
                                                    "Processor"
                                                    ]["Version"]
                                            }
                                        </p>
                                    </div>
                                    <div className="col-6 spec">
                                        <span>Ram {this.props.specificationActivities["currentSpec"]["specs"]["Hardware"]["Memory"]["Maximum Total Memory Size"] ? `Capacity | Total Size` : `Size`} </span>
                                        <p>
                                            {
                                                this.props
                                                    .specificationActivities[
                                                    "currentSpec"
                                                    ]["specs"]["Hardware"][
                                                    "Memory"
                                                    ]["Maximum Capacity"]
                                            }{this.props.specificationActivities["currentSpec"]["specs"]["Hardware"]["Memory"]["Maximum Total Memory Size"] ? ` | ${this.props.specificationActivities["currentSpec"]["specs"]["Hardware"]["Memory"]["Maximum Total Memory Size"]}` : ``}
                                        </p>
                                    </div>
                                    <div className="col-6 spec">
                                        <span>HDD</span>
                                        <p>
                                            {`${this.props.specificationActivities["currentSpec"]["specs"]["Hardware"]["Disk"]["size"]} ${this.props.specificationActivities["currentSpec"]["specs"]["Hardware"]["Disk"]["vendor"]}`}
                                        </p>
                                    </div>

                                    <button
                                        className="spec-btn red-btn"
                                        onClick={() =>
                                            this.props.showDetail(
                                                this.props
                                                    .specificationActivities[
                                                    "currentSpec"
                                                    ]
                                            )
                                        }
                                    >
                                        <i className="icon-file-text"></i>
                                        Specification Details
                                    </button>
                                </React.Fragment>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    specificationUploading: hallsStoreSelectors.specificationUploading(state),
    specificationUploaded: hallsStoreSelectors.specificationUploaded(state),
    specificationActivitiesLoading:
        hallsStoreSelectors.specificationActivitiesLoading(state),
    specificationActivities: hallsStoreSelectors.specificationActivities(state),
    serverLicenseState: hallsStoreSelectors.serverLicenseState(state)
});

const mapDispatchToProps = {
    uploadSystemSpec: HallsActionCreators.uploadSystemSpec,
    clearSuccessUploadSpec: HallsActionCreators.clearSuccessUploadSpec
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SystemSpec));
